import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SeatTradeSearchResults from '../../containers/SeatTrade/SeatTradeSearchResults'

import Search from '../Search'
import getFormValues from '../../utils/getFormValues'

class SeatTrade extends Component {
  componentDidMount() {
    if (this.props.fetchTourOperators) {
      this.props.getTourOperators()
    }
  }

  componentDidUpdate({ userCustomTopCode, fields }) {
    const formValues = getFormValues(fields)

    if (
      userCustomTopCode !== this.props.userCustomTopCode &&
      (formValues.departureAirport &&
        formValues.arrivalAirport &&
        formValues.startDate &&
        formValues.endDate)
    ) {
      this.props.resetTouroperatorField()
      this.props.resubmitForm(formValues)
    }
  }

  componentWillUnmount() {
    this.props.resetSearch()
  }

  render() {
    const {
      seatTradeIsRequestCompleted,
      seatTradeIsFetching,
      seatsAreBeingTraded,
      ...rest
    } = this.props

    return (
      <React.Fragment>
        <Search {...rest} />
        {(seatTradeIsRequestCompleted ||
          seatTradeIsFetching ||
          seatsAreBeingTraded) && <SeatTradeSearchResults {...rest} />}
      </React.Fragment>
    )
  }
}

SeatTrade.propTypes = {
  requestSeatTradeSearchResults: PropTypes.func.isRequired,
  getTourOperators: PropTypes.func.isRequired,
  departureAirport: PropTypes.string,
  arrivalAirport: PropTypes.string,
  resetSearch: PropTypes.func.isRequired,
}

export default SeatTrade
